import { memo } from 'react'
import { mdiCancel } from '@mdi/js'

import { makePublicUrl } from 'app/utils/publicUrl'
import { homeDeviceInformationMessages as messages } from '../messages'
import theme from 'theme_'
import { SignalIconImg, SignalIconImgWrap } from './styles'
import { FormattedMessage } from 'react-intl'

const SignalWeakSvg = makePublicUrl('images/networkIcons/signalWeak.svg')
const SignalFairSvg = makePublicUrl('images/networkIcons/signalFair.svg')
const SignalGoodSvg = makePublicUrl('images/networkIcons/signalGood.svg')
const SignalStrongSvg = makePublicUrl('images/networkIcons/signalStrong.svg')

interface DeviceInformationCardProps {
  rsrp?: number | undefined
  rsrq?: number | undefined
  dbm?: number | undefined
  size?: number
}

const statuses = {
  0: {
    icon: mdiCancel,
    color: theme.colors.error,
    textColor: theme.colors.duneWarmGrey,
    bgColor: theme.colors.lightRed,
    text: messages.noSignal,
  },
  1: {
    icon: SignalWeakSvg,
    color: theme.colors.error,
    textColor: theme.colors.error,
    bgColor: theme.colors.lightRed,
    text: messages.weak,
  },
  2: {
    icon: SignalFairSvg,
    color: theme.colors.statusYellow,
    textColor: theme.colors.statusYellow,
    bgColor: theme.colors.lightYellow,
    text: messages.fair,
  },
  3: {
    icon: SignalGoodSvg,
    color: theme.colors.successGreen,
    textColor: theme.colors.successGreen,
    bgColor: theme.colors.successBack,
    text: messages.good,
  },
  4: {
    icon: SignalStrongSvg,
    color: theme.colors.successGreen,
    textColor: theme.colors.successGreen,
    bgColor: theme.colors.successBack,
    text: messages.strong,
  },
}

export const getCellStatus = (
  rsrp: number | undefined,
  rsrq: number | undefined
) => {
  let s = statuses[0]

  if ((rsrp && rsrp > -90.0) || (rsrq && rsrq > -9.0)) {
    s = statuses[4]
  }
  if ((rsrp && rsrp <= -90.0) || (rsrq && rsrq <= -9.0)) {
    s = statuses[3]
  }
  if ((rsrp && rsrp < -106.0) || (rsrq && rsrq < -12.0)) {
    s = statuses[2]
  }
  if ((rsrp && rsrp < -120) || (rsrq && rsrq < -14)) {
    s = statuses[1]
  }
  if (rsrp == null || rsrq == null) {
    s = statuses[0]
  }

  return s
}

export const getWifiStatus = (dbm: number | undefined) => {
  let s = statuses[0]

  if (dbm && dbm <= -76) {
    s = statuses[1]
  }
  if (dbm && dbm > -76 && dbm <= -69) {
    s = statuses[2]
  }
  if (dbm && dbm > -69 && dbm <= -49) {
    s = statuses[3]
  }
  if (dbm && dbm > -49) {
    s = statuses[4]
  }
  if (dbm == null) {
    s = statuses[0]
  }

  return s
}

function DeviceInformationCard({
  rsrp,
  rsrq,
  dbm,
}: DeviceInformationCardProps) {
  const status = rsrp && rsrq ? getCellStatus(rsrp, rsrq) : getWifiStatus(dbm)

  if (status.icon === mdiCancel) {
    return (
      <strong>
        {' '}
        <FormattedMessage {...messages.notConnected} />
      </strong>
    )
  }

  return (
    <SignalIconImgWrap>
      <SignalIconImg src={status.icon} />
    </SignalIconImgWrap>
  )
}

export default memo(DeviceInformationCard)
